// removed by extract-text-webpack-plugin
module.exports = {"Account":"Account","AccountContent":"AccountContent","AccountTitle":"AccountTitle","Title":"Title","RightMenu":"RightMenu","MenuItem":"MenuItem","AccountData":"AccountData","TabTable":"TabTable","NavTab":"NavTab"};


//////////////////
// WEBPACK FOOTER
// ./src/screens/Account/styles.scss
// module id = 2191
// module chunks = 10